import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/billing/plans",
	lazy(() => import("./AdminPlansPage"))
);